<template>
  <div class="checkIn-item-page">
    <div class="item_box"
         @click="goHomePage(data)">
      <div class="index_pic">
        <img :src="data.indexpic"
             alt="index_pic">
      </div>
      <p class="name">{{data.name?data.name:'消防设施技术实务打卡'}}</p>
      <p class="description">{{data.description}}</p>
      <div class="join">
        <span class="">参加打卡人数：{{data.people}}人</span>
        <div class="joinBtn" v-if="showBtn"
             :class="data.join_status==1?'haveJoinBtn':''">
          <slot name="btn"></slot>
        </div>
      </div>
      <img class="status_img"
           v-if="statusImg"
           :src="statusImg"
           alt="status_img">
    </div>
    <slot name="quit"></slot>
  </div>
</template>

<script>

export default {
  name: "CheckInItem",
  props: {
    data: {
      type: Object
    },
    statusImg: {
      type: String
    },
    showBtn:{
      type:Boolean,
      default: true
    }
  },
  data () {
    return {
    };
  },
  methods: {
    join_status (status) {
      if (status == 0) {
        return '加入打卡';
      } else if (status == 1) {
        return '已加入';
      } else {
        return '加入打卡';
      }
    },
    goHomePage (data) {
      this.$emit('goHomePage', data)
    }
  }
};
</script>

<style lang="scss" scoped>
.checkIn-item-page {
  font-family: PingFang SC;
  color: #333;
  font-size: 24px;
  .item_box {
    position: relative;
    margin-top: 30px;
    .status_img {
      position: absolute;
      top: 0;
      right: 0;
      width: 89px;
      height: 89px;
    }
    .index_pic {
      height: 300px;
      img {
        width: 100%;
        height: 100%;
        border-radius: 5px;
      }
      margin: 27px 0;
    }
    .name {
      font-size: 30px;
      font-weight: 500;
      line-height: 34px;
    }
    .description {
      margin: 27px 0;
      color: #999;
      font-weight: 400;
      line-height: 30px;
      @include lines-eps(2);
    }
    .join {
      margin-bottom: 30px;
      .joinBtn {
        margin-top: -14px;
        float: right;
        width: 124px;
        height: 46px;
        line-height: 46px;
        text-align: center;
        border-radius: 4px;
        background: $theme_color;
        color: #ffffff;
      }
      .haveJoinBtn {
        background: #bfbfbf;
      }
    }
  }
}
</style>
